import React, { createContext, useContext } from "react";
import type { ReactNode } from "react";

type ContextValue = {
  inMiniHeader: boolean;
};

export const MiniHeaderIndicatorContext = createContext<ContextValue>({
  inMiniHeader: false,
});

type Props = {
  children: ReactNode;
};

export const MiniHeaderIndicatorContextProvider: React.FunctionComponent<Props> = ({
  children,
}) => (
  <MiniHeaderIndicatorContext.Provider value={{ inMiniHeader: true }}>
    {children}
  </MiniHeaderIndicatorContext.Provider>
);

MiniHeaderIndicatorContext.displayName = "MiniHeaderIndicatorContext";

export const useMiniHeaderIndicatorContext = () => useContext(MiniHeaderIndicatorContext);
